import { jsx as de } from "react/jsx-runtime";
import { n as at } from "./emotion-styled.browser.esm.js";
import { d as ge, w as ct } from "./warning.js";
import { b as Ce, a as xe, c as ut, V as dt, d as Be, e as ne, R as mt, t as ft, F as me, i as pt, N as qe, f as gt, L as ht, W as bt, g as yt, h as vt } from "./ContextIsolator.js";
import { C as he, n as Q, g as $t, o as Ge, u as te, m as Ct, R as U, y as xt, ad as wt, ae as Ot, E as Et, P as Fe, L as St, z as It, af as Nt, k as Xe, f as Ft, K as jt } from "./CSSMotionList.js";
import * as l from "react";
import { createContext as _t, isValidElement as Mt } from "react";
import { z as Ke, a as je } from "./zoom.js";
import { g as Pt } from "./collapse.js";
import { D as Rt, V as Vt, a as Dt, g as _e, s as Lt, l as Tt } from "./index.js";
import { a as Wt } from "./useSize.js";
import { S as zt, o as Ht } from "./omit.js";
import { c as At } from "./reactNode.js";
import { r as fe, u as Bt } from "./useBreakpoint.js";
import { u as qt, a as Gt } from "./index2.js";
import { _ as Xt } from "./extends.js";
import { I as Kt } from "./AntdIcon.js";
import { T as Yt } from "./index6.js";
import { u as kt } from "./useLocale.js";
import { R as Ut, a as Jt } from "./ExclamationCircleFilled.js";
import { R as Qt } from "./CloseCircleFilled.js";
import { R as Zt } from "./LoadingOutlined.js";
const Me = (e) => typeof e == "object" && e != null && e.nodeType === 1, Pe = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", ve = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const r = getComputedStyle(e, null);
    return Pe(r.overflowY, t) || Pe(r.overflowX, t) || ((n) => {
      const o = ((s) => {
        if (!s.ownerDocument || !s.ownerDocument.defaultView) return null;
        try {
          return s.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(n);
      return !!o && (o.clientHeight < n.scrollHeight || o.clientWidth < n.scrollWidth);
    })(e);
  }
  return !1;
}, ce = (e, t, r, n, o, s, a, i) => s < e && a > t || s > e && a < t ? 0 : s <= e && i <= r || a >= t && i >= r ? s - e - n : a > t && i < r || s < e && i > r ? a - t + o : 0, en = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, Re = (e, t) => {
  var r, n, o, s;
  if (typeof document > "u") return [];
  const { scrollMode: a, block: i, inline: d, boundary: m, skipOverflowHiddenElements: g } = t, I = typeof m == "function" ? m : (T) => T !== m;
  if (!Me(e)) throw new TypeError("Invalid target");
  const V = document.scrollingElement || document.documentElement, P = [];
  let $ = e;
  for (; Me($) && I($); ) {
    if ($ = en($), $ === V) {
      P.push($);
      break;
    }
    $ != null && $ === document.body && ve($) && !ve(document.documentElement) || $ != null && ve($, g) && P.push($);
  }
  const x = (n = (r = window.visualViewport) == null ? void 0 : r.width) != null ? n : innerWidth, y = (s = (o = window.visualViewport) == null ? void 0 : o.height) != null ? s : innerHeight, { scrollX: f, scrollY: w } = window, { height: c, width: u, top: S, right: N, bottom: O, left: v } = e.getBoundingClientRect(), { top: h, right: b, bottom: j, left: B } = ((T) => {
    const p = window.getComputedStyle(T);
    return { top: parseFloat(p.scrollMarginTop) || 0, right: parseFloat(p.scrollMarginRight) || 0, bottom: parseFloat(p.scrollMarginBottom) || 0, left: parseFloat(p.scrollMarginLeft) || 0 };
  })(e);
  let D = i === "start" || i === "nearest" ? S - h : i === "end" ? O + j : S + c / 2 - h + j, C = d === "center" ? v + u / 2 - B + b : d === "end" ? N + b : v - B;
  const z = [];
  for (let T = 0; T < P.length; T++) {
    const p = P[T], { height: H, width: E, top: A, right: k, bottom: le, left: K } = p.getBoundingClientRect();
    if (a === "if-needed" && S >= 0 && v >= 0 && O <= y && N <= x && S >= A && O <= le && v >= K && N <= k) return z;
    const Z = getComputedStyle(p), q = parseInt(Z.borderLeftWidth, 10), ee = parseInt(Z.borderTopWidth, 10), Y = parseInt(Z.borderRightWidth, 10), F = parseInt(Z.borderBottomWidth, 10);
    let R = 0, _ = 0;
    const M = "offsetWidth" in p ? p.offsetWidth - p.clientWidth - q - Y : 0, W = "offsetHeight" in p ? p.offsetHeight - p.clientHeight - ee - F : 0, G = "offsetWidth" in p ? p.offsetWidth === 0 ? 0 : E / p.offsetWidth : 0, re = "offsetHeight" in p ? p.offsetHeight === 0 ? 0 : H / p.offsetHeight : 0;
    if (V === p) R = i === "start" ? D : i === "end" ? D - y : i === "nearest" ? ce(w, w + y, y, ee, F, w + D, w + D + c, c) : D - y / 2, _ = d === "start" ? C : d === "center" ? C - x / 2 : d === "end" ? C - x : ce(f, f + x, x, q, Y, f + C, f + C + u, u), R = Math.max(0, R + w), _ = Math.max(0, _ + f);
    else {
      R = i === "start" ? D - A - ee : i === "end" ? D - le + F + W : i === "nearest" ? ce(A, le, H, ee, F + W, D, D + c, c) : D - (A + H / 2) + W / 2, _ = d === "start" ? C - K - q : d === "center" ? C - (K + E / 2) + M / 2 : d === "end" ? C - k + Y + M : ce(K, k, E, q, Y + M, C, C + u, u);
      const { scrollLeft: oe, scrollTop: L } = p;
      R = re === 0 ? 0 : Math.max(0, Math.min(L + R / re, p.scrollHeight - H / re + W)), _ = G === 0 ? 0 : Math.max(0, Math.min(oe + _ / G, p.scrollWidth - E / G + M)), D += L - R, C += oe - _;
    }
    z.push({ el: p, top: R, left: _ });
  }
  return z;
}, tn = (e) => e === !1 ? { block: "end", inline: "nearest" } : ((t) => t === Object(t) && Object.keys(t).length !== 0)(e) ? e : { block: "start", inline: "nearest" };
function nn(e, t) {
  if (!e.isConnected || !((o) => {
    let s = o;
    for (; s && s.parentNode; ) {
      if (s.parentNode === document) return !0;
      s = s.parentNode instanceof ShadowRoot ? s.parentNode.host : s.parentNode;
    }
    return !1;
  })(e)) return;
  const r = ((o) => {
    const s = window.getComputedStyle(o);
    return { top: parseFloat(s.scrollMarginTop) || 0, right: parseFloat(s.scrollMarginRight) || 0, bottom: parseFloat(s.scrollMarginBottom) || 0, left: parseFloat(s.scrollMarginLeft) || 0 };
  })(e);
  if (((o) => typeof o == "object" && typeof o.behavior == "function")(t)) return t.behavior(Re(e, t));
  const n = typeof t == "boolean" || t == null ? void 0 : t.behavior;
  for (const { el: o, top: s, left: a } of Re(e, tn(t))) {
    const i = s - r.top + r.bottom, d = a - r.left + r.right;
    o.scroll({ top: i, left: d, behavior: n });
  }
}
const Ye = /* @__PURE__ */ _t({});
var rn = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function Ve(e) {
  return typeof e == "number" ? `${e} ${e} auto` : /^\d+(\.\d+)?(px|em|rem|%)$/.test(e) ? `0 0 ${e}` : e;
}
const on = ["xs", "sm", "md", "lg", "xl", "xxl"], we = /* @__PURE__ */ l.forwardRef((e, t) => {
  const {
    getPrefixCls: r,
    direction: n
  } = l.useContext(he), {
    gutter: o,
    wrap: s
  } = l.useContext(Ye), {
    prefixCls: a,
    span: i,
    order: d,
    offset: m,
    push: g,
    pull: I,
    className: V,
    children: P,
    flex: $,
    style: x
  } = e, y = rn(e, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]), f = r("col", a), [w, c, u] = qt(f), S = {};
  let N = {};
  on.forEach((h) => {
    let b = {};
    const j = e[h];
    typeof j == "number" ? b.span = j : typeof j == "object" && (b = j || {}), delete y[h], N = Object.assign(Object.assign({}, N), {
      [`${f}-${h}-${b.span}`]: b.span !== void 0,
      [`${f}-${h}-order-${b.order}`]: b.order || b.order === 0,
      [`${f}-${h}-offset-${b.offset}`]: b.offset || b.offset === 0,
      [`${f}-${h}-push-${b.push}`]: b.push || b.push === 0,
      [`${f}-${h}-pull-${b.pull}`]: b.pull || b.pull === 0,
      [`${f}-rtl`]: n === "rtl"
    }), b.flex && (N[`${f}-${h}-flex`] = !0, S[`--${f}-${h}-flex`] = Ve(b.flex));
  });
  const O = Q(f, {
    [`${f}-${i}`]: i !== void 0,
    [`${f}-order-${d}`]: d,
    [`${f}-offset-${m}`]: m,
    [`${f}-push-${g}`]: g,
    [`${f}-pull-${I}`]: I
  }, V, N, c, u), v = {};
  if (o && o[0] > 0) {
    const h = o[0] / 2;
    v.paddingLeft = h, v.paddingRight = h;
  }
  return $ && (v.flex = Ve($), s === !1 && !v.minWidth && (v.minWidth = 0)), w(/* @__PURE__ */ l.createElement("div", Object.assign({}, y, {
    style: Object.assign(Object.assign(Object.assign({}, v), x), S),
    className: O,
    ref: t
  }), P));
});
process.env.NODE_ENV !== "production" && (we.displayName = "Col");
function ln(e, t) {
  const r = [void 0, void 0], n = Array.isArray(e) ? e : [e, void 0], o = t || {
    xs: !0,
    sm: !0,
    md: !0,
    lg: !0,
    xl: !0,
    xxl: !0
  };
  return n.forEach((s, a) => {
    if (typeof s == "object" && s !== null)
      for (let i = 0; i < fe.length; i++) {
        const d = fe[i];
        if (o[d] && s[d] !== void 0) {
          r[a] = s[d];
          break;
        }
      }
    else
      r[a] = s;
  }), r;
}
var sn = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function De(e, t) {
  const [r, n] = l.useState(typeof e == "string" ? e : ""), o = () => {
    if (typeof e == "string" && n(e), typeof e == "object")
      for (let s = 0; s < fe.length; s++) {
        const a = fe[s];
        if (!t || !t[a])
          continue;
        const i = e[a];
        if (i !== void 0) {
          n(i);
          return;
        }
      }
  };
  return l.useEffect(() => {
    o();
  }, [JSON.stringify(e), t]), r;
}
const ke = /* @__PURE__ */ l.forwardRef((e, t) => {
  const {
    prefixCls: r,
    justify: n,
    align: o,
    className: s,
    style: a,
    children: i,
    gutter: d = 0,
    wrap: m
  } = e, g = sn(e, ["prefixCls", "justify", "align", "className", "style", "children", "gutter", "wrap"]), {
    getPrefixCls: I,
    direction: V
  } = l.useContext(he), P = Bt(!0, null), $ = De(o, P), x = De(n, P), y = I("row", r), [f, w, c] = Gt(y), u = ln(d, P), S = Q(y, {
    [`${y}-no-wrap`]: m === !1,
    [`${y}-${x}`]: x,
    [`${y}-${$}`]: $,
    [`${y}-rtl`]: V === "rtl"
  }, s, w, c), N = {}, O = u[0] != null && u[0] > 0 ? u[0] / -2 : void 0;
  O && (N.marginLeft = O, N.marginRight = O);
  const [v, h] = u;
  N.rowGap = h;
  const b = l.useMemo(() => ({
    gutter: [v, h],
    wrap: m
  }), [v, h, m]);
  return f(/* @__PURE__ */ l.createElement(Ye.Provider, {
    value: b
  }, /* @__PURE__ */ l.createElement("div", Object.assign({}, g, {
    className: S,
    style: Object.assign(Object.assign({}, N), a),
    ref: t
  }), i)));
});
process.env.NODE_ENV !== "production" && (ke.displayName = "Row");
function an(e) {
  return e == null ? null : typeof e == "object" && !/* @__PURE__ */ Mt(e) ? e : {
    title: e
  };
}
function pe(e) {
  const [t, r] = l.useState(e);
  return l.useEffect(() => {
    const n = setTimeout(() => {
      r(e);
    }, e.length ? 0 : 10);
    return () => {
      clearTimeout(n);
    };
  }, [e]), t;
}
const cn = (e) => {
  const {
    componentCls: t
  } = e, r = `${t}-show-help`, n = `${t}-show-help-item`;
  return {
    [r]: {
      // Explain holder
      transition: `opacity ${e.motionDurationFast} ${e.motionEaseInOut}`,
      "&-appear, &-enter": {
        opacity: 0,
        "&-active": {
          opacity: 1
        }
      },
      "&-leave": {
        opacity: 1,
        "&-active": {
          opacity: 0
        }
      },
      // Explain
      [n]: {
        overflow: "hidden",
        transition: `height ${e.motionDurationFast} ${e.motionEaseInOut},
                     opacity ${e.motionDurationFast} ${e.motionEaseInOut},
                     transform ${e.motionDurationFast} ${e.motionEaseInOut} !important`,
        [`&${n}-appear, &${n}-enter`]: {
          transform: "translateY(-5px)",
          opacity: 0,
          "&-active": {
            transform: "translateY(0)",
            opacity: 1
          }
        },
        [`&${n}-leave-active`]: {
          transform: "translateY(-5px)"
        }
      }
    }
  };
}, un = (e) => ({
  legend: {
    display: "block",
    width: "100%",
    marginBottom: e.marginLG,
    padding: 0,
    color: e.colorTextDescription,
    fontSize: e.fontSizeLG,
    lineHeight: "inherit",
    border: 0,
    borderBottom: `${te(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
  },
  'input[type="search"]': {
    boxSizing: "border-box"
  },
  // Position radios and checkboxes better
  'input[type="radio"], input[type="checkbox"]': {
    lineHeight: "normal"
  },
  'input[type="file"]': {
    display: "block"
  },
  // Make range inputs behave like textual form controls
  'input[type="range"]': {
    display: "block",
    width: "100%"
  },
  // Make multiple select elements height not fixed
  "select[multiple], select[size]": {
    height: "auto"
  },
  // Focus for file, radio, and checkbox
  "input[type='file']:focus,\n  input[type='radio']:focus,\n  input[type='checkbox']:focus": {
    outline: 0,
    boxShadow: `0 0 0 ${te(e.controlOutlineWidth)} ${e.controlOutline}`
  },
  // Adjust output element
  output: {
    display: "block",
    paddingTop: 15,
    color: e.colorText,
    fontSize: e.fontSize,
    lineHeight: e.lineHeight
  }
}), Le = (e, t) => {
  const {
    formItemCls: r
  } = e;
  return {
    [r]: {
      [`${r}-label > label`]: {
        height: t
      },
      [`${r}-control-input`]: {
        minHeight: t
      }
    }
  };
}, dn = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [e.componentCls]: Object.assign(Object.assign(Object.assign({}, Ge(e)), un(e)), {
      [`${t}-text`]: {
        display: "inline-block",
        paddingInlineEnd: e.paddingSM
      },
      // ================================================================
      // =                             Size                             =
      // ================================================================
      "&-small": Object.assign({}, Le(e, e.controlHeightSM)),
      "&-large": Object.assign({}, Le(e, e.controlHeightLG))
    })
  };
}, mn = (e) => {
  const {
    formItemCls: t,
    iconCls: r,
    rootPrefixCls: n,
    antCls: o,
    labelRequiredMarkColor: s,
    labelColor: a,
    labelFontSize: i,
    labelHeight: d,
    labelColonMarginInlineStart: m,
    labelColonMarginInlineEnd: g,
    itemMarginBottom: I
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, Ge(e)), {
      marginBottom: I,
      verticalAlign: "top",
      "&-with-help": {
        transition: "none"
      },
      [`&-hidden,
        &-hidden${o}-row`]: {
        // https://github.com/ant-design/ant-design/issues/26141
        display: "none"
      },
      "&-has-warning": {
        [`${t}-split`]: {
          color: e.colorError
        }
      },
      "&-has-error": {
        [`${t}-split`]: {
          color: e.colorWarning
        }
      },
      // ==============================================================
      // =                            Label                           =
      // ==============================================================
      [`${t}-label`]: {
        flexGrow: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textAlign: "end",
        verticalAlign: "middle",
        "&-left": {
          textAlign: "start"
        },
        "&-wrap": {
          overflow: "unset",
          lineHeight: e.lineHeight,
          whiteSpace: "unset",
          "> label": {
            verticalAlign: "middle",
            textWrap: "balance"
          }
        },
        "> label": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          height: d,
          color: a,
          fontSize: i,
          [`> ${r}`]: {
            fontSize: e.fontSize,
            verticalAlign: "top"
          },
          [`&${t}-required`]: {
            "&::before": {
              display: "inline-block",
              marginInlineEnd: e.marginXXS,
              color: s,
              fontSize: e.fontSize,
              fontFamily: "SimSun, sans-serif",
              lineHeight: 1,
              content: '"*"'
            },
            [`&${t}-required-mark-hidden, &${t}-required-mark-optional`]: {
              "&::before": {
                display: "none"
              }
            }
          },
          // Optional mark
          [`${t}-optional`]: {
            display: "inline-block",
            marginInlineStart: e.marginXXS,
            color: e.colorTextDescription,
            [`&${t}-required-mark-hidden`]: {
              display: "none"
            }
          },
          // Optional mark
          [`${t}-tooltip`]: {
            color: e.colorTextDescription,
            cursor: "help",
            writingMode: "horizontal-tb",
            marginInlineStart: e.marginXXS
          },
          "&::after": {
            content: '":"',
            position: "relative",
            marginBlock: 0,
            marginInlineStart: m,
            marginInlineEnd: g
          },
          [`&${t}-no-colon::after`]: {
            content: '"\\a0"'
          }
        }
      },
      // ==============================================================
      // =                            Input                           =
      // ==============================================================
      [`${t}-control`]: {
        "--ant-display": "flex",
        flexDirection: "column",
        flexGrow: 1,
        [`&:first-child:not([class^="'${n}-col-'"]):not([class*="' ${n}-col-'"])`]: {
          width: "100%"
        },
        "&-input": {
          position: "relative",
          display: "flex",
          alignItems: "center",
          minHeight: e.controlHeight,
          "&-content": {
            flex: "auto",
            maxWidth: "100%"
          }
        }
      },
      // ==============================================================
      // =                           Explain                          =
      // ==============================================================
      [t]: {
        "&-additional": {
          display: "flex",
          flexDirection: "column"
        },
        "&-explain, &-extra": {
          clear: "both",
          color: e.colorTextDescription,
          fontSize: e.fontSize,
          lineHeight: e.lineHeight
        },
        "&-explain-connected": {
          width: "100%"
        },
        "&-extra": {
          minHeight: e.controlHeightSM,
          transition: `color ${e.motionDurationMid} ${e.motionEaseOut}`
          // sync input color transition
        },
        "&-explain": {
          "&-error": {
            color: e.colorError
          },
          "&-warning": {
            color: e.colorWarning
          }
        }
      },
      [`&-with-help ${t}-explain`]: {
        height: "auto",
        opacity: 1
      },
      // ==============================================================
      // =                        Feedback Icon                       =
      // ==============================================================
      [`${t}-feedback-icon`]: {
        fontSize: e.fontSize,
        textAlign: "center",
        visibility: "visible",
        animationName: Ke,
        animationDuration: e.motionDurationMid,
        animationTimingFunction: e.motionEaseOutBack,
        pointerEvents: "none",
        "&-success": {
          color: e.colorSuccess
        },
        "&-error": {
          color: e.colorError
        },
        "&-warning": {
          color: e.colorWarning
        },
        "&-validating": {
          color: e.colorPrimary
        }
      }
    })
  };
}, Te = (e, t) => {
  const {
    formItemCls: r
  } = e;
  return {
    [`${t}-horizontal`]: {
      [`${r}-label`]: {
        flexGrow: 0
      },
      [`${r}-control`]: {
        flex: "1 1 0",
        // https://github.com/ant-design/ant-design/issues/32777
        // https://github.com/ant-design/ant-design/issues/33773
        minWidth: 0
      },
      // Do not change this to `ant-col-24`! `-24` match all the responsive rules
      // https://github.com/ant-design/ant-design/issues/32980
      // https://github.com/ant-design/ant-design/issues/34903
      // https://github.com/ant-design/ant-design/issues/44538
      [`${r}-label[class$='-24'], ${r}-label[class*='-24 ']`]: {
        [`& + ${r}-control`]: {
          minWidth: "unset"
        }
      }
    }
  };
}, fn = (e) => {
  const {
    componentCls: t,
    formItemCls: r,
    inlineItemMarginBottom: n
  } = e;
  return {
    [`${t}-inline`]: {
      display: "flex",
      flexWrap: "wrap",
      [r]: {
        flex: "none",
        marginInlineEnd: e.margin,
        marginBottom: n,
        "&-row": {
          flexWrap: "nowrap"
        },
        [`> ${r}-label,
        > ${r}-control`]: {
          display: "inline-block",
          verticalAlign: "top"
        },
        [`> ${r}-label`]: {
          flex: "none"
        },
        [`${t}-text`]: {
          display: "inline-block"
        },
        [`${r}-has-feedback`]: {
          display: "inline-block"
        }
      }
    }
  };
}, J = (e) => ({
  padding: e.verticalLabelPadding,
  margin: e.verticalLabelMargin,
  whiteSpace: "initial",
  textAlign: "start",
  "> label": {
    margin: 0,
    "&::after": {
      // https://github.com/ant-design/ant-design/issues/43538
      visibility: "hidden"
    }
  }
}), Ue = (e) => {
  const {
    componentCls: t,
    formItemCls: r,
    rootPrefixCls: n
  } = e;
  return {
    [`${r} ${r}-label`]: J(e),
    // ref: https://github.com/ant-design/ant-design/issues/45122
    [`${t}:not(${t}-inline)`]: {
      [r]: {
        flexWrap: "wrap",
        [`${r}-label, ${r}-control`]: {
          // When developer pass `xs: { span }`,
          // It should follow the `xs` screen config
          // ref: https://github.com/ant-design/ant-design/issues/44386
          [`&:not([class*=" ${n}-col-xs"])`]: {
            flex: "0 0 100%",
            maxWidth: "100%"
          }
        }
      }
    }
  };
}, pn = (e) => {
  const {
    componentCls: t,
    formItemCls: r,
    antCls: n
  } = e;
  return {
    [`${t}-vertical`]: {
      [`${r}:not(${r}-horizontal)`]: {
        [`${r}-row`]: {
          flexDirection: "column"
        },
        [`${r}-label > label`]: {
          height: "auto"
        },
        [`${r}-control`]: {
          width: "100%"
        },
        [`${r}-label,
        ${n}-col-24${r}-label,
        ${n}-col-xl-24${r}-label`]: J(e)
      }
    },
    [`@media (max-width: ${te(e.screenXSMax)})`]: [Ue(e), {
      [t]: {
        [`${r}:not(${r}-horizontal)`]: {
          [`${n}-col-xs-24${r}-label`]: J(e)
        }
      }
    }],
    [`@media (max-width: ${te(e.screenSMMax)})`]: {
      [t]: {
        [`${r}:not(${r}-horizontal)`]: {
          [`${n}-col-sm-24${r}-label`]: J(e)
        }
      }
    },
    [`@media (max-width: ${te(e.screenMDMax)})`]: {
      [t]: {
        [`${r}:not(${r}-horizontal)`]: {
          [`${n}-col-md-24${r}-label`]: J(e)
        }
      }
    },
    [`@media (max-width: ${te(e.screenLGMax)})`]: {
      [t]: {
        [`${r}:not(${r}-horizontal)`]: {
          [`${n}-col-lg-24${r}-label`]: J(e)
        }
      }
    }
  };
}, gn = (e) => {
  const {
    formItemCls: t,
    antCls: r
  } = e;
  return {
    [`${t}-vertical`]: {
      [`${t}-row`]: {
        flexDirection: "column"
      },
      [`${t}-label > label`]: {
        height: "auto"
      },
      [`${t}-control`]: {
        width: "100%"
      }
    },
    [`${t}-vertical ${t}-label,
      ${r}-col-24${t}-label,
      ${r}-col-xl-24${t}-label`]: J(e),
    [`@media (max-width: ${te(e.screenXSMax)})`]: [Ue(e), {
      [t]: {
        [`${r}-col-xs-24${t}-label`]: J(e)
      }
    }],
    [`@media (max-width: ${te(e.screenSMMax)})`]: {
      [t]: {
        [`${r}-col-sm-24${t}-label`]: J(e)
      }
    },
    [`@media (max-width: ${te(e.screenMDMax)})`]: {
      [t]: {
        [`${r}-col-md-24${t}-label`]: J(e)
      }
    },
    [`@media (max-width: ${te(e.screenLGMax)})`]: {
      [t]: {
        [`${r}-col-lg-24${t}-label`]: J(e)
      }
    }
  };
}, hn = (e) => ({
  labelRequiredMarkColor: e.colorError,
  labelColor: e.colorTextHeading,
  labelFontSize: e.fontSize,
  labelHeight: e.controlHeight,
  labelColonMarginInlineStart: e.marginXXS / 2,
  labelColonMarginInlineEnd: e.marginXS,
  itemMarginBottom: e.marginLG,
  verticalLabelPadding: `0 0 ${e.paddingXS}px`,
  verticalLabelMargin: 0,
  inlineItemMarginBottom: 0
}), Je = (e, t) => Ct(e, {
  formItemCls: `${e.componentCls}-item`,
  rootPrefixCls: t
}), Oe = $t("Form", (e, {
  rootPrefixCls: t
}) => {
  const r = Je(e, t);
  return [dn(r), mn(r), cn(r), Te(r, r.componentCls), Te(r, r.formItemCls), fn(r), pn(r), gn(r), Pt(r), Ke];
}, hn, {
  // Let From style before the Grid
  // ref https://github.com/ant-design/ant-design/issues/44386
  order: -1e3
}), We = [];
function $e(e, t, r, n = 0) {
  return {
    key: typeof e == "string" ? e : `${t}-${n}`,
    error: e,
    errorStatus: r
  };
}
const Qe = ({
  help: e,
  helpStatus: t,
  errors: r = We,
  warnings: n = We,
  className: o,
  fieldId: s,
  onVisibleChanged: a
}) => {
  const {
    prefixCls: i
  } = l.useContext(Ce), d = `${i}-item-explain`, m = xe(i), [g, I, V] = Oe(i, m), P = l.useMemo(() => je(i), [i]), $ = pe(r), x = pe(n), y = l.useMemo(() => e != null ? [$e(e, "help", t)] : [].concat(U($.map((c, u) => $e(c, "error", "error", u))), U(x.map((c, u) => $e(c, "warning", "warning", u)))), [e, t, $, x]), f = l.useMemo(() => {
    const c = {};
    return y.forEach(({
      key: u
    }) => {
      c[u] = (c[u] || 0) + 1;
    }), y.map((u, S) => Object.assign(Object.assign({}, u), {
      key: c[u.key] > 1 ? `${u.key}-fallback-${S}` : u.key
    }));
  }, [y]), w = {};
  return s && (w.id = `${s}_help`), g(/* @__PURE__ */ l.createElement(xt, {
    motionDeadline: P.motionDeadline,
    motionName: `${i}-show-help`,
    visible: !!f.length,
    onVisibleChanged: a
  }, (c) => {
    const {
      className: u,
      style: S
    } = c;
    return /* @__PURE__ */ l.createElement("div", Object.assign({}, w, {
      className: Q(d, u, V, m, o, I),
      style: S
    }), /* @__PURE__ */ l.createElement(wt, Object.assign({
      keys: f
    }, je(i), {
      motionName: `${i}-show-help-item`,
      component: !1
    }), (N) => {
      const {
        key: O,
        error: v,
        errorStatus: h,
        className: b,
        style: j
      } = N;
      return /* @__PURE__ */ l.createElement("div", {
        key: O,
        className: Q(b, {
          [`${d}-${h}`]: h
        }),
        style: j
      }, v);
    }));
  }));
}, bn = ["parentNode"], yn = "form_item";
function ae(e) {
  return e === void 0 || e === !1 ? [] : Array.isArray(e) ? e : [e];
}
function Ze(e, t) {
  if (!e.length)
    return;
  const r = e.join("_");
  return t ? `${t}_${r}` : bn.includes(r) ? `${yn}_${r}` : r;
}
function et(e, t, r, n, o, s) {
  let a = n;
  return s !== void 0 ? a = s : r.validating ? a = "validating" : e.length ? a = "error" : t.length ? a = "warning" : (r.touched || o && r.validated) && (a = "success"), a;
}
var vn = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function ze(e) {
  return ae(e).join("_");
}
function He(e, t) {
  const r = t.getFieldInstance(e), n = Ot(r);
  if (n)
    return n;
  const o = Ze(ae(e), t.__INTERNAL__.name);
  if (o)
    return document.getElementById(o);
}
function tt(e) {
  const [t] = ut(), r = l.useRef({}), n = l.useMemo(() => e ?? Object.assign(Object.assign({}, t), {
    __INTERNAL__: {
      itemRef: (o) => (s) => {
        const a = ze(o);
        s ? r.current[a] = s : delete r.current[a];
      }
    },
    scrollToField: (o, s = {}) => {
      const {
        focus: a
      } = s, i = vn(s, ["focus"]), d = He(o, n);
      d && (nn(d, Object.assign({
        scrollMode: "if-needed",
        block: "nearest"
      }, i)), a && n.focusField(o));
    },
    focusField: (o) => {
      var s, a;
      const i = n.getFieldInstance(o);
      typeof (i == null ? void 0 : i.focus) == "function" ? i.focus() : (a = (s = He(o, n)) === null || s === void 0 ? void 0 : s.focus) === null || a === void 0 || a.call(s);
    },
    getFieldInstance: (o) => {
      const s = ze(o);
      return r.current[s];
    }
  }), [e, t]);
  return [n];
}
const ue = {};
function $n({
  name: e
}) {
  const t = ge("Form");
  l.useEffect(() => {
    if (e)
      return ue[e] = (ue[e] || 0) + 1, process.env.NODE_ENV !== "production" && t(ue[e] <= 1, "usage", "There exist multiple Form with same `name`."), () => {
        ue[e] -= 1;
      };
  }, [e]);
}
var Cn = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const xn = (e, t) => {
  const r = l.useContext(Rt), {
    getPrefixCls: n,
    direction: o,
    requiredMark: s,
    colon: a,
    scrollToFirstError: i,
    className: d,
    style: m
  } = Et("form"), {
    prefixCls: g,
    className: I,
    rootClassName: V,
    size: P,
    disabled: $ = r,
    form: x,
    colon: y,
    labelAlign: f,
    labelWrap: w,
    labelCol: c,
    wrapperCol: u,
    hideRequiredMark: S,
    layout: N = "horizontal",
    scrollToFirstError: O,
    requiredMark: v,
    onFinishFailed: h,
    name: b,
    style: j,
    feedbackIcons: B,
    variant: D
  } = e, C = Cn(e, ["prefixCls", "className", "rootClassName", "size", "disabled", "form", "colon", "labelAlign", "labelWrap", "labelCol", "wrapperCol", "hideRequiredMark", "layout", "scrollToFirstError", "requiredMark", "onFinishFailed", "name", "style", "feedbackIcons", "variant"]), z = Wt(P), T = l.useContext(Vt);
  process.env.NODE_ENV !== "production" && $n(e);
  const p = l.useMemo(() => v !== void 0 ? v : S ? !1 : s !== void 0 ? s : !0, [S, v, s]), H = y ?? a, E = n("form", g), A = xe(E), [k, le, K] = Oe(E, A), Z = Q(E, `${E}-${N}`, {
    [`${E}-hide-required-mark`]: p === !1,
    // todo: remove in next major version
    [`${E}-rtl`]: o === "rtl",
    [`${E}-${z}`]: z
  }, K, A, le, d, I, V), [q] = tt(x), {
    __INTERNAL__: ee
  } = q;
  ee.name = b;
  const Y = l.useMemo(() => ({
    name: b,
    labelAlign: f,
    labelCol: c,
    labelWrap: w,
    wrapperCol: u,
    vertical: N === "vertical",
    colon: H,
    requiredMark: p,
    itemRef: ee.itemRef,
    form: q,
    feedbackIcons: B
  }), [b, f, c, u, N, H, p, q, B]), F = l.useRef(null);
  l.useImperativeHandle(t, () => {
    var M;
    return Object.assign(Object.assign({}, q), {
      nativeElement: (M = F.current) === null || M === void 0 ? void 0 : M.nativeElement
    });
  });
  const R = (M, W) => {
    if (M) {
      let G = {
        block: "nearest"
      };
      typeof M == "object" && (G = Object.assign(Object.assign({}, G), M)), q.scrollToField(W, G);
    }
  }, _ = (M) => {
    if (h == null || h(M), M.errorFields.length) {
      const W = M.errorFields[0].name;
      if (O !== void 0) {
        R(O, W);
        return;
      }
      i !== void 0 && R(i, W);
    }
  };
  return k(/* @__PURE__ */ l.createElement(dt.Provider, {
    value: D
  }, /* @__PURE__ */ l.createElement(Dt, {
    disabled: $
  }, /* @__PURE__ */ l.createElement(zt.Provider, {
    value: z
  }, /* @__PURE__ */ l.createElement(Be, {
    // This is not list in API, we pass with spread
    validateMessages: T
  }, /* @__PURE__ */ l.createElement(ne.Provider, {
    value: Y
  }, /* @__PURE__ */ l.createElement(mt, Object.assign({
    id: b
  }, C, {
    name: b,
    onFinishFailed: _,
    form: q,
    ref: F,
    style: Object.assign(Object.assign({}, m), j),
    className: Z
  }))))))));
}, nt = /* @__PURE__ */ l.forwardRef(xn);
process.env.NODE_ENV !== "production" && (nt.displayName = "Form");
function wn(e) {
  if (typeof e == "function")
    return e;
  const t = ft(e);
  return t.length <= 1 ? t[0] : t;
}
const rt = () => {
  const {
    status: e,
    errors: t = [],
    warnings: r = []
  } = l.useContext(me);
  if (process.env.NODE_ENV !== "production") {
    const n = ge("Form.Item");
    process.env.NODE_ENV !== "production" && n(e !== void 0, "usage", "Form.Item.useStatus should be used under Form.Item component. For more information: https://u.ant.design/form-item-usestatus");
  }
  return {
    status: e,
    errors: t,
    warnings: r
  };
};
rt.Context = me;
function On(e) {
  const [t, r] = l.useState(e), n = l.useRef(null), o = l.useRef([]), s = l.useRef(!1);
  l.useEffect(() => (s.current = !1, () => {
    s.current = !0, Fe.cancel(n.current), n.current = null;
  }), []);
  function a(i) {
    s.current || (n.current === null && (o.current = [], n.current = Fe(() => {
      n.current = null, r((d) => {
        let m = d;
        return o.current.forEach((g) => {
          m = g(m);
        }), m;
      });
    })), o.current.push(i));
  }
  return [t, a];
}
function En() {
  const {
    itemRef: e
  } = l.useContext(ne), t = l.useRef({});
  function r(n, o) {
    const s = o && typeof o == "object" && St(o), a = n.join("_");
    return (t.current.name !== a || t.current.originRef !== s) && (t.current.name = a, t.current.originRef = s, t.current.ref = It(e(n), s)), t.current.ref;
  }
  return r;
}
const Sn = (e) => {
  const {
    formItemCls: t
  } = e;
  return {
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      // Fallback for IE, safe to remove we not support it anymore
      [`${t}-control`]: {
        display: "flex"
      }
    }
  };
}, In = Nt(["Form", "item-item"], (e, {
  rootPrefixCls: t
}) => {
  const r = Je(e, t);
  return [Sn(r)];
});
var Nn = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const Fn = 24, jn = (e) => {
  const {
    prefixCls: t,
    status: r,
    labelCol: n,
    wrapperCol: o,
    children: s,
    errors: a,
    warnings: i,
    _internalItemRender: d,
    extra: m,
    help: g,
    fieldId: I,
    marginBottom: V,
    onErrorVisibleChanged: P,
    label: $
  } = e, x = `${t}-item`, y = l.useContext(ne), f = l.useMemo(() => {
    let C = Object.assign({}, o || y.wrapperCol || {});
    return $ === null && !n && !o && y.labelCol && [void 0, "xs", "sm", "md", "lg", "xl", "xxl"].forEach((T) => {
      const p = T ? [T] : [], H = _e(y.labelCol, p), E = typeof H == "object" ? H : {}, A = _e(C, p), k = typeof A == "object" ? A : {};
      "span" in E && !("offset" in k) && E.span < Fn && (C = Lt(C, [].concat(p, ["offset"]), E.span));
    }), C;
  }, [o, y]), w = Q(`${x}-control`, f.className), c = l.useMemo(() => Nn(y, ["labelCol", "wrapperCol"]), [y]), u = l.useRef(null), [S, N] = l.useState(0);
  Xe(() => {
    m && u.current ? N(u.current.clientHeight) : N(0);
  }, [m]);
  const O = /* @__PURE__ */ l.createElement("div", {
    className: `${x}-control-input`
  }, /* @__PURE__ */ l.createElement("div", {
    className: `${x}-control-input-content`
  }, s)), v = l.useMemo(() => ({
    prefixCls: t,
    status: r
  }), [t, r]), h = V !== null || a.length || i.length ? /* @__PURE__ */ l.createElement(Ce.Provider, {
    value: v
  }, /* @__PURE__ */ l.createElement(Qe, {
    fieldId: I,
    errors: a,
    warnings: i,
    help: g,
    helpStatus: r,
    className: `${x}-explain-connected`,
    onVisibleChanged: P
  })) : null, b = {};
  I && (b.id = `${I}_extra`);
  const j = m ? /* @__PURE__ */ l.createElement("div", Object.assign({}, b, {
    className: `${x}-extra`,
    ref: u
  }), m) : null, B = h || j ? /* @__PURE__ */ l.createElement("div", {
    className: `${x}-additional`,
    style: V ? {
      minHeight: V + S
    } : {}
  }, h, j) : null, D = d && d.mark === "pro_table_render" && d.render ? d.render(e, {
    input: O,
    errorList: h,
    extra: j
  }) : /* @__PURE__ */ l.createElement(l.Fragment, null, O, B);
  return /* @__PURE__ */ l.createElement(ne.Provider, {
    value: c
  }, /* @__PURE__ */ l.createElement(we, Object.assign({}, f, {
    className: w
  }), D), /* @__PURE__ */ l.createElement(In, {
    prefixCls: t
  }));
};
var _n = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z" } }] }, name: "question-circle", theme: "outlined" }, Mn = function(t, r) {
  return /* @__PURE__ */ l.createElement(Kt, Xt({}, t, {
    ref: r,
    icon: _n
  }));
}, ot = /* @__PURE__ */ l.forwardRef(Mn);
process.env.NODE_ENV !== "production" && (ot.displayName = "QuestionCircleOutlined");
var Pn = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const Rn = ({
  prefixCls: e,
  label: t,
  htmlFor: r,
  labelCol: n,
  labelAlign: o,
  colon: s,
  required: a,
  requiredMark: i,
  tooltip: d,
  vertical: m
}) => {
  var g;
  const [I] = kt("Form"), {
    labelAlign: V,
    labelCol: P,
    labelWrap: $,
    colon: x
  } = l.useContext(ne);
  if (!t)
    return null;
  const y = n || P || {}, f = o || V, w = `${e}-item-label`, c = Q(w, f === "left" && `${w}-left`, y.className, {
    [`${w}-wrap`]: !!$
  });
  let u = t;
  const S = s === !0 || x !== !1 && s !== !1;
  S && !m && typeof t == "string" && t.trim() && (u = t.replace(/[:|：]\s*$/, ""));
  const O = an(d);
  if (O) {
    const {
      icon: D = /* @__PURE__ */ l.createElement(ot, null)
    } = O, C = Pn(O, ["icon"]), z = /* @__PURE__ */ l.createElement(Yt, Object.assign({}, C), /* @__PURE__ */ l.cloneElement(D, {
      className: `${e}-item-tooltip`,
      title: "",
      onClick: (T) => {
        T.preventDefault();
      },
      tabIndex: null
    }));
    u = /* @__PURE__ */ l.createElement(l.Fragment, null, u, z);
  }
  const v = i === "optional", h = typeof i == "function", b = i === !1;
  h ? u = i(u, {
    required: !!a
  }) : v && !a && (u = /* @__PURE__ */ l.createElement(l.Fragment, null, u, /* @__PURE__ */ l.createElement("span", {
    className: `${e}-item-optional`,
    title: ""
  }, (I == null ? void 0 : I.optional) || ((g = Tt.Form) === null || g === void 0 ? void 0 : g.optional))));
  let j;
  b ? j = "hidden" : (v || h) && (j = "optional");
  const B = Q({
    [`${e}-item-required`]: a,
    [`${e}-item-required-mark-${j}`]: j,
    [`${e}-item-no-colon`]: !S
  });
  return /* @__PURE__ */ l.createElement(we, Object.assign({}, y, {
    className: c
  }), /* @__PURE__ */ l.createElement("label", {
    htmlFor: r,
    className: B,
    title: typeof t == "string" ? t : ""
  }, u));
}, Vn = {
  success: Ut,
  warning: Jt,
  error: Qt,
  validating: Zt
};
function lt({
  children: e,
  errors: t,
  warnings: r,
  hasFeedback: n,
  validateStatus: o,
  prefixCls: s,
  meta: a,
  noStyle: i
}) {
  const d = `${s}-item`, {
    feedbackIcons: m
  } = l.useContext(ne), g = et(t, r, a, null, !!n, o), {
    isFormItemInput: I,
    status: V,
    hasFeedback: P,
    feedbackIcon: $
  } = l.useContext(me), x = l.useMemo(() => {
    var y;
    let f;
    if (n) {
      const c = n !== !0 && n.icons || m, u = g && ((y = c == null ? void 0 : c({
        status: g,
        errors: t,
        warnings: r
      })) === null || y === void 0 ? void 0 : y[g]), S = g && Vn[g];
      f = u !== !1 && S ? /* @__PURE__ */ l.createElement("span", {
        className: Q(`${d}-feedback-icon`, `${d}-feedback-icon-${g}`)
      }, u || /* @__PURE__ */ l.createElement(S, null)) : null;
    }
    const w = {
      status: g || "",
      errors: t,
      warnings: r,
      hasFeedback: !!n,
      feedbackIcon: f,
      isFormItemInput: !0
    };
    return i && (w.status = (g ?? V) || "", w.isFormItemInput = I, w.hasFeedback = !!(n ?? P), w.feedbackIcon = n !== void 0 ? w.feedbackIcon : $), w;
  }, [g, n, i, I, V]);
  return /* @__PURE__ */ l.createElement(me.Provider, {
    value: x
  }, e);
}
var Dn = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
function Ln(e) {
  const {
    prefixCls: t,
    className: r,
    rootClassName: n,
    style: o,
    help: s,
    errors: a,
    warnings: i,
    validateStatus: d,
    meta: m,
    hasFeedback: g,
    hidden: I,
    children: V,
    fieldId: P,
    required: $,
    isRequired: x,
    onSubItemMetaChange: y,
    layout: f
  } = e, w = Dn(e, ["prefixCls", "className", "rootClassName", "style", "help", "errors", "warnings", "validateStatus", "meta", "hasFeedback", "hidden", "children", "fieldId", "required", "isRequired", "onSubItemMetaChange", "layout"]), c = `${t}-item`, {
    requiredMark: u,
    vertical: S
  } = l.useContext(ne), N = S || f === "vertical", O = l.useRef(null), v = pe(a), h = pe(i), b = s != null, j = !!(b || a.length || i.length), B = !!O.current && pt(O.current), [D, C] = l.useState(null);
  Xe(() => {
    if (j && O.current) {
      const E = getComputedStyle(O.current);
      C(parseInt(E.marginBottom, 10));
    }
  }, [j, B]);
  const z = (E) => {
    E || C(null);
  }, p = ((E = !1) => {
    const A = E ? v : m.errors, k = E ? h : m.warnings;
    return et(A, k, m, "", !!g, d);
  })(), H = Q(c, r, n, {
    [`${c}-with-help`]: b || v.length || h.length,
    // Status
    [`${c}-has-feedback`]: p && g,
    [`${c}-has-success`]: p === "success",
    [`${c}-has-warning`]: p === "warning",
    [`${c}-has-error`]: p === "error",
    [`${c}-is-validating`]: p === "validating",
    [`${c}-hidden`]: I,
    // Layout
    [`${c}-${f}`]: f
  });
  return /* @__PURE__ */ l.createElement("div", {
    className: H,
    style: o,
    ref: O
  }, /* @__PURE__ */ l.createElement(ke, Object.assign({
    className: `${c}-row`
  }, Ht(w, [
    "_internalItemRender",
    "colon",
    "dependencies",
    "extra",
    "fieldKey",
    "getValueFromEvent",
    "getValueProps",
    "htmlFor",
    "id",
    // It is deprecated because `htmlFor` is its replacement.
    "initialValue",
    "isListField",
    "label",
    "labelAlign",
    "labelCol",
    "labelWrap",
    "messageVariables",
    "name",
    "normalize",
    "noStyle",
    "preserve",
    "requiredMark",
    "rules",
    "shouldUpdate",
    "trigger",
    "tooltip",
    "validateFirst",
    "validateTrigger",
    "valuePropName",
    "wrapperCol",
    "validateDebounce"
  ])), /* @__PURE__ */ l.createElement(Rn, Object.assign({
    htmlFor: P
  }, e, {
    requiredMark: u,
    required: $ ?? x,
    prefixCls: t,
    vertical: N
  })), /* @__PURE__ */ l.createElement(jn, Object.assign({}, e, m, {
    errors: v,
    warnings: h,
    prefixCls: t,
    status: p,
    help: s,
    marginBottom: D,
    onErrorVisibleChanged: z
  }), /* @__PURE__ */ l.createElement(qe.Provider, {
    value: y
  }, /* @__PURE__ */ l.createElement(lt, {
    prefixCls: t,
    meta: m,
    errors: m.errors,
    warnings: m.warnings,
    hasFeedback: g,
    // Already calculated
    validateStatus: p
  }, V)))), !!D && /* @__PURE__ */ l.createElement("div", {
    className: `${c}-margin-offset`,
    style: {
      marginBottom: -D
    }
  }));
}
const Tn = "__SPLIT__";
function Wn(e, t) {
  const r = Object.keys(e), n = Object.keys(t);
  return r.length === n.length && r.every((o) => {
    const s = e[o], a = t[o];
    return s === a || typeof s == "function" || typeof a == "function";
  });
}
const zn = /* @__PURE__ */ l.memo(({
  children: e
}) => e, (e, t) => Wn(e.control, t.control) && e.update === t.update && e.childProps.length === t.childProps.length && e.childProps.every((r, n) => r === t.childProps[n]));
function Ae() {
  return {
    errors: [],
    warnings: [],
    touched: !1,
    validating: !1,
    name: [],
    validated: !1
  };
}
function Hn(e) {
  const {
    name: t,
    noStyle: r,
    className: n,
    dependencies: o,
    prefixCls: s,
    shouldUpdate: a,
    rules: i,
    children: d,
    required: m,
    label: g,
    messageVariables: I,
    trigger: V = "onChange",
    validateTrigger: P,
    hidden: $,
    help: x,
    layout: y
  } = e, {
    getPrefixCls: f
  } = l.useContext(he), {
    name: w
  } = l.useContext(ne), c = wn(d), u = typeof c == "function", S = l.useContext(qe), {
    validateTrigger: N
  } = l.useContext(gt), O = P !== void 0 ? P : N, v = t != null, h = f("form", s), b = xe(h), [j, B, D] = Oe(h, b), C = ge("Form.Item");
  process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && C(t !== null, "usage", "`null` is passed as `name` property");
  const z = l.useContext(ht), T = l.useRef(null), [p, H] = On({}), [E, A] = Ft(() => Ae()), k = (F) => {
    const R = z == null ? void 0 : z.getKey(F.name);
    if (A(F.destroy ? Ae() : F, !0), r && x !== !1 && S) {
      let _ = F.name;
      if (F.destroy)
        _ = T.current || _;
      else if (R !== void 0) {
        const [M, W] = R;
        _ = [M].concat(U(W)), T.current = _;
      }
      S(F, _);
    }
  }, le = (F, R) => {
    H((_) => {
      const M = Object.assign({}, _), G = [].concat(U(F.name.slice(0, -1)), U(R)).join(Tn);
      return F.destroy ? delete M[G] : M[G] = F, M;
    });
  }, [K, Z] = l.useMemo(() => {
    const F = U(E.errors), R = U(E.warnings);
    return Object.values(p).forEach((_) => {
      F.push.apply(F, U(_.errors || [])), R.push.apply(R, U(_.warnings || []));
    }), [F, R];
  }, [p, E.errors, E.warnings]), q = En();
  function ee(F, R, _) {
    return r && !$ ? /* @__PURE__ */ l.createElement(lt, {
      prefixCls: h,
      hasFeedback: e.hasFeedback,
      validateStatus: e.validateStatus,
      meta: E,
      errors: K,
      warnings: Z,
      noStyle: !0
    }, F) : /* @__PURE__ */ l.createElement(Ln, Object.assign({
      key: "row"
    }, e, {
      className: Q(n, D, b, B),
      prefixCls: h,
      fieldId: R,
      isRequired: _,
      errors: K,
      warnings: Z,
      meta: E,
      onSubItemMetaChange: le,
      layout: y
    }), F);
  }
  if (!v && !u && !o)
    return j(ee(c));
  let Y = {};
  return typeof g == "string" ? Y.label = g : t && (Y.label = String(t)), I && (Y = Object.assign(Object.assign({}, Y), I)), j(/* @__PURE__ */ l.createElement(bt, Object.assign({}, e, {
    messageVariables: Y,
    trigger: V,
    validateTrigger: O,
    onMetaChange: k
  }), (F, R, _) => {
    const M = ae(t).length && R ? R.name : [], W = Ze(M, w), G = m !== void 0 ? m : !!(i != null && i.some((L) => {
      if (L && typeof L == "object" && L.required && !L.warningOnly)
        return !0;
      if (typeof L == "function") {
        const se = L(_);
        return (se == null ? void 0 : se.required) && !(se != null && se.warningOnly);
      }
      return !1;
    })), re = Object.assign({}, F);
    let oe = null;
    if (process.env.NODE_ENV !== "production" && C(!(a && o), "usage", "`shouldUpdate` and `dependencies` shouldn't be used together. See https://u.ant.design/form-deps."), Array.isArray(c) && v)
      process.env.NODE_ENV !== "production" && C(!1, "usage", "A `Form.Item` with a `name` prop must have a single child element. For information on how to render more complex form items, see https://u.ant.design/complex-form-item."), oe = c;
    else if (u && (!(a || o) || v))
      process.env.NODE_ENV !== "production" && C(!!(a || o), "usage", "A `Form.Item` with a render function must have either `shouldUpdate` or `dependencies`."), process.env.NODE_ENV !== "production" && C(!v, "usage", "A `Form.Item` with a render function cannot be a field, and thus cannot have a `name` prop.");
    else if (o && !u && !v)
      process.env.NODE_ENV !== "production" && C(!1, "usage", "Must set `name` or use a render function when `dependencies` is set.");
    else if (/* @__PURE__ */ l.isValidElement(c)) {
      process.env.NODE_ENV !== "production" && C(c.props.defaultValue === void 0, "usage", "`defaultValue` will not work on controlled Field. You should use `initialValues` of Form instead.");
      const L = Object.assign(Object.assign({}, c.props), re);
      if (L.id || (L.id = W), x || K.length > 0 || Z.length > 0 || e.extra) {
        const ie = [];
        (x || K.length > 0) && ie.push(`${W}_help`), e.extra && ie.push(`${W}_extra`), L["aria-describedby"] = ie.join(" ");
      }
      K.length > 0 && (L["aria-invalid"] = "true"), G && (L["aria-required"] = "true"), jt(c) && (L.ref = q(M, c)), new Set([].concat(U(ae(V)), U(ae(O)))).forEach((ie) => {
        L[ie] = (...Ee) => {
          var Se, Ie, be, Ne, ye;
          (be = re[ie]) === null || be === void 0 || (Se = be).call.apply(Se, [re].concat(Ee)), (ye = (Ne = c.props)[ie]) === null || ye === void 0 || (Ie = ye).call.apply(Ie, [Ne].concat(Ee));
        };
      });
      const it = [L["aria-required"], L["aria-invalid"], L["aria-describedby"]];
      oe = /* @__PURE__ */ l.createElement(zn, {
        control: re,
        update: c,
        childProps: it
      }, At(c, L));
    } else u && (a || o) && !v ? oe = c(_) : (process.env.NODE_ENV !== "production" && C(!M.length || !!r, "usage", "`name` is only used for validate React element. If you are using Form.Item as layout display, please remove `name` instead."), oe = c);
    return ee(oe, W, G);
  }));
}
const st = Hn;
st.useStatus = rt;
var An = function(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
    t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
};
const Bn = (e) => {
  var {
    prefixCls: t,
    children: r
  } = e, n = An(e, ["prefixCls", "children"]);
  if (process.env.NODE_ENV !== "production") {
    const i = ge("Form.List");
    process.env.NODE_ENV !== "production" && i(typeof n.name == "number" || (Array.isArray(n.name) ? !!n.name.length : !!n.name), "usage", "Miss `name` prop.");
  }
  const {
    getPrefixCls: o
  } = l.useContext(he), s = o("form", t), a = l.useMemo(() => ({
    prefixCls: s,
    status: "error"
  }), [s]);
  return /* @__PURE__ */ l.createElement(yt, Object.assign({}, n), (i, d, m) => /* @__PURE__ */ l.createElement(Ce.Provider, {
    value: a
  }, r(i.map((g) => Object.assign(Object.assign({}, g), {
    fieldKey: g.key
  })), d, {
    errors: m.errors,
    warnings: m.warnings
  })));
};
function qn() {
  const {
    form: e
  } = l.useContext(ne);
  return e;
}
const X = nt;
X.Item = st;
X.List = Bn;
X.ErrorList = Qe;
X.useForm = tt;
X.useFormInstance = qn;
X.useWatch = vt;
X.Provider = Be;
X.create = () => {
  process.env.NODE_ENV !== "production" && ct(!1, "Form", "antd v4 removed `Form.create`. Please remove or use `@ant-design/compatible` instead.");
};
const Gn = {
  left: "start",
  right: "end",
  center: "center"
}, Xn = at(X.Item)`
  width: 100%;
  display: flex;
  ${({ align: e }) => e && `justify-content: ${Gn[e]};`}

  .ant-form-item-row {
    width: 100%;
  }
`, Kn = ({ label: e, ...t }) => {
  const r = typeof e == "string" ? /* @__PURE__ */ de("div", { className: "font-medium", children: e }) : e;
  return /* @__PURE__ */ de(X.Item, { ...t, label: r });
}, Yn = ({
  children: e,
  align: t = "right",
  ...r
}) => /* @__PURE__ */ de(Xn, { ...r, align: t, children: e }), kn = {
  sm: "small",
  md: "middle",
  lg: "large"
}, Un = ({
  scrollToFirstError: e = !0,
  size: t = "lg",
  layout: r = "vertical",
  ...n
}) => /* @__PURE__ */ de(
  X,
  {
    ...n,
    scrollToFirstError: e,
    size: kn[t],
    layout: r
  }
), Jn = X.useForm, Qn = X.useWatch, $r = Object.assign(Un, {
  Item: Kn,
  Footer: Yn,
  useForm: Jn,
  useWatch: Qn
});
export {
  $r as F
};
